import Skeleton from '@/common/components/Skeleton';
import { Fragment } from 'react/jsx-runtime';

const FinancialSummaryLoadingState = () => {
  return new Array(2).fill(null).map((_, index) => (
    <Fragment key={`skeleton_${index}`}>
      {index > 0 && <div className='h-px p-px'></div>}

      <div className='flex flex-col gap-2'>
        <Skeleton width={140} />

        <div className='flex items-center gap-1'>
          <Skeleton className='size-4' />

          <Skeleton width={80} />
        </div>

        <div className='flex items-center gap-1'>
          <Skeleton className='size-4' />

          <Skeleton width={100} />
        </div>
      </div>
    </Fragment>
  ))
}

export default FinancialSummaryLoadingState;
